import axios from "axios";
import Config from "src/config";

const v2_actionAnalises = (clienteId, querys) => {
    return axios({
        method: "get",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/ai/${clienteId}/analysis${querys}`
        });
};

export default v2_actionAnalises;
